import { useQuery } from "@tanstack/react-query"
import { Moment } from "config"
import { API } from "config"

const useProductReport = (id, period) => useQuery({ queryKey: ['product-report', id], queryFn: async () => {
    if(!id) return null
    const callback = await API.get(`/products/${id}/report?start=${Moment(period[0]).unix()}&end=${Moment(period[1]).unix()}`)
    return callback?.data
}})

export default useProductReport